/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"

type UsePaymentInvoiceListBySoProps = {
  params: {
    sales_order_id?: number
  }
}

type Response = {
  payload: {
    invoice_id: number
    sales_order_id: number
    trx_code: string
    transaction_date: string
    approve_status: number
    approve_date: string
    approve_by: number
    memo: string
    invoice_status: number
    invoice_status_date: string | null
    promise_date: string
    referensi: string
    delivery_no: number
    freight: string
    customer_id: number
    location_id: number
    address: string
    total: string
    depo: string
    payment: string
  }[]
}

export function usePaymentInvoiceListBySo({
  params
}: UsePaymentInvoiceListBySoProps) {
  const api = useApi()
  const [data, setData] = useState<Response["payload"]>([])
  const [isLoading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    api
      .get("paymentinvoice/payment_invoice_by_so", { params })
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? []
        setData(data)
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(false)
    }
  }, [params.sales_order_id])

  return {
    data,
    isLoading,
    refetch,
    dropdown: data.map((item) => ({ value: item, label: item }))
  }
}
